import { render } from "./BannerRegListComponent.vue?vue&type=template&id=101bed20&scoped=true&ts=true"
import script from "./BannerRegListComponent.vue?vue&type=script&lang=ts"
export * from "./BannerRegListComponent.vue?vue&type=script&lang=ts"

import "./BannerRegListComponent.vue?vue&type=style&index=0&id=101bed20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101bed20"]])

export default __exports__